<div [ngClass]="{border: isWithBorder, focus: isFocus, error: isError, placeholder: !value.length}">
  <mat-autocomplete test-id="fw-chip-input-autocomplete" #autoValue="matAutocomplete"
    (optionSelected)="selectChip($event)" panelWidth="auto">
    <mat-option *ngFor="let suggestion of filteredSuggestions" [value]="suggestion.value"
      [matTooltip]="suggestion.tooltip" matTooltipClass="tooltip-stretch">
      {{ suggestion.display }}
    </mat-option>
  </mat-autocomplete>
  <mat-chip-grid #chipList [disabled]="disabled">
    <div [class.no-values]="!value.length" cdkDropList cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)" class="chips-input-container">
      @for(value of chips; track value) {
      @if(isOutlined) {
      <fw-tooltip [title]="value">
        <fw-chip [style.max-width]="maxOptionWidth" cdkDrag [disabled]="disabled" [cdkDragDisabled]="disableDrag"
          color="primary" [title]="value" [showClose]="true" (focus)="onFocusIn($event)" (blur)="onFocusOut($event)"
          (close)="removeChip($index)"></fw-chip>
      </fw-tooltip>
      } @else {
      <fw-tooltip [title]="value">
        <fw-chip [style.max-width]="maxOptionWidth" cdkDrag [disabled]="disabled" [cdkDragDisabled]="disableDrag"
          [style]="getChipStyle(value)" variant="focused" color="slate" [title]="value" [showClose]="true"
          (focus)="onFocusIn($event)" (blur)="onFocusOut($event)" (close)="removeChip($index)"></fw-chip>
      </fw-tooltip>
      }
      }

      <input class="chips-input-field" #chipInput (focus)="onFocusIn($event)" (blur)="onFocusOut($event)"
        (keyup)="onValueChange($any($event.target).value)" (paste)="paste($event)" [placeholder]="placeholder"
        [matAutocomplete]="autoValue" [matChipInputFor]="chipList" [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="onMatChipInputTokenEnd($event)">
    </div>
  </mat-chip-grid>
</div>
